// @flow
// fc-auth reducer
import authReducers from 'fc-auth/src/reducers'

// Eula Reducers
import composeEulaReducers from './reducers/eula'

// Login Operator
import composeLoginReducers from './reducers/login'

// Request Reset Password Operator
import composeRequestResetReducers from './reducers/requestReset'

// Reset Password Reducer
import composeResetPasswordReducers from './reducers/resetPassword'

const loginReducers = composeLoginReducers()
const requestResetReducers = composeRequestResetReducers()
const resetPasswordReducers = composeResetPasswordReducers()
const eulaReducers = composeEulaReducers()

export default {
  ...authReducers,
  ...loginReducers,
  ...requestResetReducers,
  ...resetPasswordReducers,
  ...eulaReducers,
}
